var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranslate = function SvgTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 2a1 1 0 0 1 1 1v1h3a1 1 0 1 1 0 2H9.578a18.9 18.9 0 0 1-1.724 4.78q.436.531.914 1.026a1 1 0 1 1-1.44 1.389 21 21 0 0 1-.554-.6 19 19 0 0 1-3.107 3.567 1 1 0 0 1-1.334-1.49 17 17 0 0 0 3.13-3.733 19 19 0 0 1-1.487-2.494 1 1 0 1 1 1.79-.89q.351.705.764 1.372c.417-.934.752-1.913.997-2.927H3a1 1 0 1 1 0-2h3V3a1 1 0 0 1 1-1m6 6a1 1 0 0 1 .894.553l2.991 5.982.02.037.99 1.98a1 1 0 1 1-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 1 1-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0 1 13 8m-1.382 6h2.764L13 11.236z",
    clipRule: "evenodd"
  })));
};
export default SvgTranslate;